import { Dropdown } from 'primereact/dropdown'
import './CommonDropDown.scss';


export const CommonDropDown = ({ label, className, error, value, isNoLabel, ...props }) => {
    return (
        <div className='form-group dropdown-wrapper'>
            <div
                className={`p-float-label common-dropdown ${value ? 'p-filled' : ''} ${error ? 'red-border' : ''}`}
            >
                <Dropdown
                    id={`common-dropdownid-${className ? `${className}-dropdown` : ''}`}
                    className={`form-control cust-normal-dropdown ${className ? `${className}-dropdown` : ''} ${isNoLabel ? 'no-label': ''}`}
                    value={value}
                    {...props}
                />
                <label htmlFor={`common-dropdownid-${className ? `${className}-dropdown` : ''}`} className={`${className ? `${className}-label` : ''}`}>
                    {label}
                </label>
                {!isNoLabel && <span className="common-dropdown-error">
                    {error ? error : ''}
                </span>}

            </div>

        </div >
    )
}